import { JSX } from "react";

import { ArchiveItem } from "models/ArchiveItem";
import Modal from "components/modal/Modal";
import { Loader } from "components/loader/Loader";
import { DocumentArchiveFolderTree } from "../components/folderTree/DocumentArchiveFolderTree";
import { DocumentArchiveFileTableInternal } from "../components/fileTable/DocumentArchiveFileTableInternal";
import { filterYearEndFolders } from "../state/documentArchiveOptions";
import { useRootStore } from "store";

type DocumentArchiveModalProps = {
  onSelectFolder?: (folder: ArchiveItem) => void;
  onSelectFile?: (file: ArchiveItem) => void;
  onDismiss: () => void;
  header?: JSX.Element;
};

export default function DocumentArchiveModal({
  onSelectFolder = () => {},
  onSelectFile = () => {},
  onDismiss,
  header = <></>
}: DocumentArchiveModalProps) {
  const { archive, global: globalState } = useRootStore((state) => state);

  const { getArchiveFolderFiles, setSelectedArchiveNodeId } = archive;

  return (
    <Modal
      onDismiss={() => onDismiss()}
      header={header}
      modalTitle="attach file"
    >
      <div className="d-flex">
        <div className={"mr-relative mb-relative"}>
          <div className={"overflow-scroll pr-3"}>
            <DocumentArchiveFolderTree
              isLoading={archive.isLoadingArchiveRoot}
              onFolderClicked={(node) => {
                getArchiveFolderFiles(globalState.workingCustomerId, node.id);

                setSelectedArchiveNodeId(node.id);
                onSelectFolder(node);
              }}
              selectedFolderId={archive.selectedFolderId}
              folders={archive.archiveRoot.filter((item) => filterYearEndFolders(item, archive.archiveRoot))}
            />
          </div>
        </div>

        <div className={"min-w-350 flex-1-1 h-100"}>
          {archive.isLoadingFolder && <Loader />}

          {!archive.isLoadingFolder && (
            <div className="overflow-scroll">
              <DocumentArchiveFileTableInternal
                onSelectFile={(file) => onSelectFile(file)}
                files={archive.selectedFolderFiles}
              />
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}
